import { Component, OnInit, ViewChild } from '@angular/core';
import { SearchComponent } from '../../../base/search/search.component';
import { SearchRequestSearchRequest } from '../../../../models/net/request/search-request-search-request';
import { SearchRequestSearchResult } from '../../../../models/net/result/search-request-search-result';
import { SearchRequestService } from '../../../../services/search-requests/search-request.service';
import { AppService } from '../../../../services/app.service';
import { SearchRequestType } from '../../../../models/data/app-core/search-request-type';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageSeverity } from '../../../../enums/message-severity';
import { SearchMarqueeComponent } from '../../../fragments/search-marquee/search-marquee.component';
import { SearchRequestBase } from '../../../../models/net/request/base/search-request-base';
import { SearchRequest } from '../../../../models/data/app-core/search-request';
import { SearchRequestEnvelope } from '../../../../models/net/envelope/search-request-envelope';
import { SearchRequestTypeEnum } from '../../../../enums/search-request-type-enum';
import { SearchPreference } from '../../../../models/data/app-core/search-preference';
import { SessionService } from '../../../../services/session/session.service';

@Component({
    selector: 'app-search-requests',
    templateUrl: './search-requests.component.html',
    styleUrls: ['./search-requests.component.css', '../../../../app.component.css']
})

export class SearchRequestsComponent extends SearchComponent implements OnInit {

    public displayedColumns: string[] = ["Avatar", "Name", "Description", "SearchRequestType", "Delete"];
    public override searchResult: SearchRequestSearchResult[] = [];
    public searchRequestEnvelopes: SearchRequestEnvelope[] = [];
    //public searchRequestTypeEnum: SearchRequestTypeEnum = SearchRequestTypeEnum.SearchRequestSearchRequest;
    public searchRequestTypeName: string = "SearchRequestEnvelope";
    public searchRequestTileComponentTypeName: string = "SearchTileComponent";

    @ViewChild("searchMarquee") searchMarquee!: SearchMarqueeComponent;

    public constructor(public override appService: AppService, public override sessionService: SessionService, public override itemService: SearchRequestService, public searchRequestService: SearchRequestService) {

        super(appService, sessionService, itemService, "searchrequest", "SearchRequest");
        super.searchRequestTypeEnum = SearchRequestTypeEnum.SearchRequestSearchRequest;
    }

    public override ngOnInit(): void {

        super.ngOnInit();
    }

    public ngAfterViewInit(): void {

        this.searchMarquee!.runSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            const searchRequest: SearchRequestSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            this.runSearch(searchRequest);
        });

        this.searchMarquee!.runSavedSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            var resourceSearchRequest: SearchRequestSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            if (resourceSearchRequest) {

                this.runSearch(resourceSearchRequest);
            }
        });
    }

    public override handleSearchPreference(searchPreference: SearchPreference): void {

        if (searchPreference.SearchPreferenceId > 0) {

            if (searchPreference.DefaultSearchRequestId) {

                this.searchMarquee!.isSavedSearchMode = true;

                this.searchMarquee!.setDefaultSearchRequestId(searchPreference.DefaultSearchRequestId);

                if (searchPreference.IsRunDefaultSearchOnLoad) {

                    this.searchMarquee!.searchRequested();
                }
            }

        } else {

            this.searchMarquee!.isSavedSearchMode = false;
        }

        this.isSearchMarqueeDisabled = false;
    }

    public override getItemIndexFromSearchResult = (id: number): number | undefined => {

        const result = this.searchResult.map((i: SearchRequestSearchResult) => i.SearchRequestId).indexOf(id, 0);

        return result;
    }

    public runSearch = (searchRequest: SearchRequestSearchRequest): void => {

        this.searchRequest = searchRequest;

        this.search();
    }
}
